export const calculateCustomizationTotal = (quantity, cost, calculationPer, unitOrInterval) => {
    let thousands = quantity / 1000;
    thousands = Math.ceil(thousands);

    let total = 0;

    if(calculationPer === 'thousand'){
        total = cost * thousands;
    } else {
        if(unitOrInterval === 'interval'){
            total = cost;
        } else {
            total = cost * quantity;
        }
    }

    return total;
}

// Artes INTEIRAS por dimensão: cada arte ocupa (arte + espaçamento) e as sobras
// são descartadas — nunca calcular dividindo área total por área da arte, isso
// superestima o encaixe assumindo que as sobras de largura/comprimento se somam.
const fitCount = (available, art, s) => Math.floor(available / (art + s));

// quantas artes cabem numa unidade W x H (uma orientação)
const fitPerUnit = (W, H, w, h, s) =>
    fitCount(W, w, s) * fitCount(H, h, s);

// Unidades (folhas ou metros de rolo) consumidas. Retorna null se a arte não cabe.
// Rolo e folha usam a mesma grade: no rolo a unidade é width_mm x height_mm
// (1 lineamento) e a sobra de cada metro é descartada — as linhas não
// atravessam a fronteira do metro. Ex.: filme 280x1000, arte 40x20, esp. 5:
// floor(280/25) x floor(1000/45) = 11 x 22 = 242 artes/metro.
export const calculateSizeUnits = (size, artW, artH, spacing, totalArts) => {
    const s = Math.max(0, spacing || 0);
    if (!size || !artW || !artH || !totalArts) return null;

    // rotação permitida: usa a orientação que rende mais artes por unidade
    const perUnit = Math.max(
        fitPerUnit(size.width_mm, size.height_mm, artW, artH, s),
        fitPerUnit(size.width_mm, size.height_mm, artH, artW, s)
    );
    if (perUnit < 1) return null;
    return Math.ceil(totalArts / perUnit);
};

export const calculateSizeCustomizationTotal = (units, costPerUnit, fixedFee, applicationCost = 0, quantity = 0) =>
    units * costPerUnit + (fixedFee || 0) + (applicationCost || 0) * (quantity || 0);
